import AfipTiposPage from '../pages/afip/AfipTiposPage'

const routes = [

     {
        name: 'AfipTiposPage',
        path: '/afip/tipos',
        component: AfipTiposPage,
        meta: {
            requiresAuth: true,
            permission: "AFIP_MENU"
        }
     }
]

export default routes;
